/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved
 *
 * Licensed under CLOUD LINUX LICENSE AGREEMENT
 * http://cloudlinux.com/docs/LICENSE.TXT
 */

import { Row } from '../../utils/row';
import { AppMode } from '../model';
import { Status } from '../../model/status';

export class ApplicationRow extends Row {
    appUri: string;
    rootDir: string;
    user: string;
    appName: string;
    version: string;
    mode: AppMode;
    runningStatus: Status;

    /**
     * Hidden field for sorting
     */
    status: string;

    public get appNameEncoded(): string {
        return encodeURIComponent(this.appName);
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/nodejs/application/application.row.ts